// extracted by mini-css-extract-plugin
module.exports = {"submit":"submit-BGUkB"};